import React from 'react';
import classnames from 'classnames';

import "./manning-online-desktop-button.scss";
import { ManningOnlineStore } from '../../store/ManningOnlineStore';

export interface IProps {
    store: ManningOnlineStore;
}
export interface IState {}

export class ManningOnlineDesktopButton extends React.Component <IProps, IState> {
    private hasBeenMounted: boolean;  
    
    constructor(props: IProps) {
        super(props);

        this.handleStateChanged = this.handleStateChanged.bind(this);
    }

    public componentDidMount(){
        this.hasBeenMounted = true;

        this.props.store.onDesktopChange(this.handleStateChanged);
    }

    public componentWillUnmount(){
        this.hasBeenMounted = false;
        this.props.store.offDesktopChange(this.handleStateChanged);
    }

    private handleStateChanged(){
        this.hasBeenMounted && this.forceUpdate();
    }

    public render(){
        return <button className={classnames("manning-online-desktop-button-root")} onClick={this.props.store.toggleDesktop}>
                    <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <defs>
                            <clipPath id="clip0_918:17065">
                                <rect width="30.0687" height="29.7499" fill="white" transform="translate(0.884766 0.416656)"/>
                            </clipPath>
                        </defs>
                        <g clipPath="url(#clip0_918:17065)">
                            <path d="M21.4906 15.9497L22.5437 19.1091H20.964C20.1215 19.1091 19.3843 19.8462 19.3843 20.6887C19.3843 21.5312 20.1215 22.2684 20.964 22.2684H23.8074C25.2818 22.2684 26.2296 20.8994 25.8083 19.5303L24.5446 15.7391C24.018 14.0541 22.3331 12.8957 20.5427 12.8957H15.0665C13.2762 12.8957 11.5912 14.0541 11.0647 15.7391L9.90625 20.6887" stroke="currentColor" strokeWidth="1.25263" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M12.3149 15.9494L11.2617 20.6888" stroke="currentColor" strokeWidth="1.07069" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M9.78655 22.2679H9.57593C8.73343 22.2679 8.10156 21.636 8.10156 20.7935V20.5829C8.10156 19.7404 8.73343 19.1085 9.57593 19.1085H9.78655C10.629 19.1085 11.2609 19.7404 11.2609 20.5829V20.7935C11.2609 21.636 10.629 22.2679 9.78655 22.2679Z" stroke="currentColor" strokeWidth="1.07069" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                            <rect x="6.83496" y="12.3166" width="5.94999" height="10.4125" fill="white"/>
                            <path d="M18.0154 10.684C20.6327 10.684 22.7544 8.56226 22.7544 5.94497C22.7544 3.32767 20.6327 1.20593 18.0154 1.20593C15.3981 1.20593 13.2764 3.32767 13.2764 5.94497C13.2764 8.56226 15.3981 10.684 18.0154 10.684Z" stroke="currentColor" strokeWidth="1.25263" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M30.4283 22.2685H1.99414V24.3747H30.4283V22.2685Z" stroke="currentColor" strokeWidth="0.894736" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M28.3213 29.64V24.3744H4.09961V29.64" stroke="currentColor" strokeWidth="0.894736" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M13.5916 18.765H4.61719V20.688H13.5916V18.765Z" fill="white" stroke="currentColor" strokeWidth="0.894736" strokeMiterlimit="13.3333" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M13.5916 15.5603H4.61719V17.4834H13.5916V15.5603Z" fill="white" stroke="currentColor" strokeWidth="0.894736" strokeMiterlimit="13.3333" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M13.5916 12.355H4.61719V14.2781H13.5916V12.355Z" fill="white" stroke="currentColor" strokeWidth="0.894736" strokeMiterlimit="13.3333" strokeLinecap="round" strokeLinejoin="round"/>
                        </g>
                    </svg>
               </button>
    }
}